import { handleActions } from 'redux-actions';

import { resourceUpserters } from '../core';
import * as actions from './customersActions';
import { type CustomersStore, mkCustomersStore } from './customersTypes';

const reducer = handleActions<
  CustomersStore,
  | ReturnType<typeof actions.getCustomersSuccess>
  | ReturnType<typeof actions.createCustomer>
  | ReturnType<typeof actions.createCustomerSuccess>
  | ReturnType<typeof actions.updateCustomer>
  | ReturnType<typeof actions.updateCustomerSuccess>
  | ReturnType<typeof actions.deleteCustomer>
  | ReturnType<typeof actions.deleteCustomerSuccess>
>(
  {
    [actions.getCustomersSuccess.type]: (state, { payload }) => resourceUpserters.upsertResources(state, payload),

    [actions.createCustomer.type]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),
    [actions.createCustomerSuccess.type]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),

    [actions.updateCustomer.type]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),
    [actions.updateCustomerSuccess.type]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),

    [actions.deleteCustomer.type]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),
    [actions.deleteCustomerSuccess.type]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),
  },
  mkCustomersStore(),
);

export default reducer;
